import Button, { Appearance, Spacing } from '@atlaskit/button';
import { Field } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';
import React from 'react';
import './copyable-field.scss';
interface Props {
  autoSelect: boolean;
  value: string;
  label: string;
  maxHeight?: string;
  buttonApperance?: Appearance;
  buttonSpacing?: Spacing;
  testId?: string;
  className?: string;
  onBtnClick?: () => void;
}

const CopyableField = (props: Props) => {
  const copyableElement = React.useRef<HTMLTextAreaElement>(null);
  const { autoSelect, value, label, maxHeight, buttonApperance = 'primary', buttonSpacing = 'default' } = props;

  React.useEffect(() => {
    if (autoSelect && copyableElement.current) {
      selectText();
    }
  }, [autoSelect, copyableElement]);

  const selectText = () => {
    if (copyableElement.current) {
      copyableElement.current.select();
    }
  };

  const copyText = () => {
    if (copyableElement.current) {
      selectText();
      document.execCommand('copy');
      props.onBtnClick && props.onBtnClick();
    }
  };

  return (
    <React.Fragment>
      <Field<string, HTMLTextAreaElement> name="copyable-element" label={label}>
        {({ fieldProps }) => (
          <TextArea
            {...fieldProps}
            isReadOnly
            value={value}
            onFocus={selectText}
            ref={copyableElement}
            maxHeight={maxHeight}
            testId={props.testId}
          />
        )}
      </Field>

      <div style={{ marginTop: '20px' }}>
        <Button
          name="copyable-button"
          aria-label="Copy link"
          spacing={buttonSpacing}
          onClick={copyText}
          className={props?.className}
        >
          Copy
        </Button>
      </div>
    </React.Fragment>
  );
};

export default CopyableField;
